export const customSymbolRenderer = {
  type: "simple",
  symbol: {
    type: "picture-marker",
    url: "/photo-symbol.png",
    width: "23.5px",
    height: "23.5px",
  },
};
